export default __webpack_public_path__ + "static/media/3-2.49e6d66f.webp";